import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { DEFAULT_LOCALE } from '../../../../components/PriceOverviewCard/models.js';
import { Divider, Flex, LabelMedium, LabelXSmall } from '../../../../primitives/index.js';
import { priceFormatter } from '../../../../utils/index.js';
import { PRICE_OVERVIEW_QA_ID, qaId } from '../../../../utils/qaId.js';
export const Travellers = ({
  items,
  locale = DEFAULT_LOCALE,
  children
}) => {
  return _jsxs(Flex, {
    gap: "global/medium",
    children: [items?.map(({
      name,
      displayPrice,
      price
    }, index) => _jsxs(Flex, {
      direction: "row",
      justifyContent: "space-between",
      "data-testid": qaId(PRICE_OVERVIEW_QA_ID, name.includes('Erwachsener') ? `traveler[${+name.charAt(0) - 1}]` : `child[${+name.charAt(0) - 1}]`),
      children: [_jsx(LabelMedium, {
        children: name
      }), _jsxs(Flex, {
        gap: "global/small",
        alignItems: "end",
        children: [_jsxs(LabelMedium, {
          children: [priceFormatter(locale, displayPrice.currency).format(displayPrice.value), displayPrice.currency === price.currency ? '' : '*']
        }), displayPrice.currency !== price.currency && _jsx(LabelXSmall, {
          color: "contentSecondary",
          children: priceFormatter(DEFAULT_LOCALE, price.currency).format(price.value)
        })]
      })]
    }, index)), children, _jsx(Divider, {
      type: "dotted",
      category: "primary"
    })]
  });
};